import fragments from '@/API/fragments';
import learning_paths from "@/API/learning_path";
import resources from "@/API/resources";
import activities from "@/API/activities";
import elements from "@/API/elements";
import members from "@/API/members";
import projects from "@/API/projects";
import uploads from "@/API/uploads";
import teams from "@/API/teams";
import organizations from "@/API/organizations";
import users from "@/API/users";
import podcasts from "@/API/podcasts";
import groups from "@/API/groups";
import courses from "@/API/courses";
import modules from "@/API/modules";

export default {
    fragments,
    learning_paths,
    resources,
    activities,
    elements,
    members,
    projects,
    uploads,
    teams,
    organizations,
    users,
    podcasts,
    groups,
    courses,
    modules,
}
